/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styles from './SmartBanner.module.css';
import { generateDeviceInfo, detectAgent } from '../../utils';
import Button from '../Button/Button';
import logo from '../../assets/app-logo.svg';
import icClose from '../../assets/ic-close.svg';
import { getAppSettings } from '../../redux/actions/settings';

function SmartBanner() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isMobile = detectAgent('mobile');
  const fullSchemeURL = `${window.location.hostname}${location?.pathname}`;
  const newDeviceInfo = generateDeviceInfo();
  const currentDate = new Date();
  const appSettings = useSelector((state) => state.appSettings?.settings);
  const title = appSettings?.['smartbanner.title']
    ? appSettings?.['smartbanner.title']
    : 'Sushiroll - Mobile App';
  const description = appSettings?.['smartbanner.description']
    ? appSettings?.['smartbanner.description']
    : 'Install our app today 📲';
  const buttonLabel = appSettings?.['smartbanner.buttonlabel']
    ? appSettings?.['smartbanner.buttonlabel']
    : 'Open App';
  const [showBanner, toggleDialog] = useState(false);

  const appConfigs = {
    iosUrlScheme:
      process.env.NODE_ENV === 'production'
        ? `sushiroll://${fullSchemeURL}`
        : `sushiroll-staging://${fullSchemeURL}`,
    androidIntent: `intent://${fullSchemeURL}#Intent;scheme=https;package=com.application.sushiroll;end`
  };

  const closeBanner = () => {
    toggleDialog((open) => !open);
    const enabledTime = currentDate.setHours(currentDate.getHours() + 1);
    localStorage.setItem('disableBanner', enabledTime);
  };

  useEffect(() => {
    if (appSettings) {
      const exclusionArray = appSettings?.['smartbanner.exclusion'].split(',');
      const excludedPage = exclusionArray.includes(location.pathname);
      if (!excludedPage) {
        toggleDialog(appSettings?.['smartbanner.active'] === 'true');
      } else {
        toggleDialog(false);
      }
    }
  }, [appSettings, location]);
  useEffect(() => {
    dispatch(
      getAppSettings([
        'smartbanner.title',
        'smartbanner.description',
        'smartbanner.buttonlabel',
        'smartbanner.active',
        'smartbanner.exclusion'
      ])
    );
  }, [dispatch]);
  useEffect(() => {
    const enabledTime = new Date(0).setUTCSeconds(
      localStorage.getItem('disableBanner')
    ); // The 0 there is the key, which sets the date to the epoch
    const currentTime = new Date(0).setUTCSeconds(currentDate);
    if (enabledTime && currentTime) {
      toggleDialog(false);
      if (enabledTime < currentTime) {
        toggleDialog(true);
        localStorage.removeItem('disableBanner');
      }
    }
  }, [currentDate]);

  const openApp = () => {
    if (newDeviceInfo?.name.toLowerCase() !== 'ios') {
      // Android Intent URL
      window.location.href = appConfigs.androidIntent;
    } else if (newDeviceInfo?.name.toLowerCase() === 'ios') {
      // iOS Universal Link with App Store fallback
      window.location.href = appConfigs.iosUrlScheme;
    }
  };

  if (isMobile && showBanner) {
    return (
      <div className={styles['wrapper']}>
        <section className={styles['section1']}>
          <img src={logo} alt='logo' className={styles['logo']} />
          <div className={styles['contentContainer']}>
            <span className={styles['title']}>{title}</span>
            <span className={styles['description']}>{description}</span>
          </div>
          <div onClick={closeBanner}>
            <img src={icClose} className={styles['btnClose']} alt='close' />
          </div>
        </section>
        <section>
          <Button className={styles['btn']} id='app_download' onClick={openApp}>
            {buttonLabel}
          </Button>
        </section>
      </div>
    );
  }
  return <div />;
}

export default SmartBanner;
